/**
 * LeadershipGrid — Leadership roster cards for the About page.
 */
import React from 'react';
import styles from './LeadershipGrid.module.css';

export const LEADERSHIP = [
  { name: 'Adel Al Jumaily', role: 'Captain', initials: 'AA' },
  { name: 'Benedict Thomas', role: 'Vice Captain', initials: 'BT' },
  { name: 'Mohammed', role: 'Engineering Lead', initials: 'M' },
  { name: 'Razeen', role: 'Design Lead', initials: 'R' },
  { name: 'Datta', role: 'Programming Lead', initials: 'D' },
];

function LeadershipGrid() {
  return (
    <div className={styles.grid}>
      {LEADERSHIP.map((member) => (
        <article key={member.name} className={styles.card}>
          <div className={styles.avatar} aria-hidden="true">
            {member.initials}
          </div>
          <div>
            <div className={styles.name}>{member.name}</div>
            <div className={styles.role}>{member.role}</div>
          </div>
        </article>
      ))}
    </div>
  );
}

export default LeadershipGrid;
